import { navCategories } from '@/mocks/nav';

interface CategorySectionProps {
  activeCategory: string;
  onSelectCategory: (category: string) => void;
}

export default function CategorySection({ activeCategory, onSelectCategory }: CategorySectionProps) {
  return (
    <section
      id="categories"
      className="scroll-mt-20 border-b border-background-200 bg-background-100 py-14 md:scroll-mt-24 md:py-20"
    >
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="max-w-2xl">
          <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-secondary-600 md:text-sm">
            <i className="ri-layout-grid-line text-base" aria-hidden="true"></i>
            Categories
          </p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">主题分类</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            按你关心的方向挑一个主题，页面会自动跳到入口列表并筛选出对应类型的站点，比一条条翻快得多。
          </p>
        </div>

        <ul className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:mt-10">
          {navCategories.map((category) => (
            <li key={category.id}>
              <button
                type="button"
                onClick={() => onSelectCategory(category.id)}
                aria-pressed={activeCategory === category.id}
                className={`group flex h-full w-full flex-col items-start rounded-lg border p-5 text-left transition-colors ${
                  activeCategory === category.id
                    ? 'border-primary-400 bg-primary-50'
                    : 'border-background-200 bg-background-50 hover:border-primary-300'
                }`}
              >
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-md text-xl transition-colors ${
                    activeCategory === category.id
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-primary-600 group-hover:bg-primary-100'
                  }`}
                >
                  <i className={category.icon} aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{category.name}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{category.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-xs text-foreground-500">
                  收录 {category.count} 个入口
                  <i className="ri-arrow-right-up-line text-sm text-primary-500" aria-hidden="true"></i>
                </span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}